import { formatDate as fd } from '@angular/common';
import { type Lang } from '@appTypes';

type DateFormat = 'yyyy-MM-dd' | 'dd-MM-yyyy' | 'yyyy-MM-ddTHH:mm' | 'yyyy-MM-ddTHH:mm:ss';

// Devuelve la fecha formateada en el formato e idioma indicados
export const formatDate = (date: Date | null, format: DateFormat, lang: Lang = 'es'): string => {
  return date === null ? '' : fd(date, format, lang === 'es' ? 'es-MX' : 'en-US');
};

// Convierte la fecha que puede ser string, a Date o null
export const toDateNullable = (date: string | Date | null, type: 'date' | 'datetime-local'): Date | null => {
  if (typeof date !== 'string')
    return date;

  if (date === '')
    return null;

  if (type === 'date')
    date = date.replace(/T.+/i, '');

  if (!/T.+/i.test(date))
    date += 'T00:00:00';

  return new Date(date);
};

// Convierte la fecha al formato de entrada en string del elemento input
export const toInputDate = (date: string | Date | null, type: 'date' | 'datetime-local', withSeconds: boolean): string => {
  return formatDate(toDateNullable(date, type), type === 'date' ? 'yyyy-MM-dd' : !withSeconds ? 'yyyy-MM-ddTHH:mm' : 'yyyy-MM-ddTHH:mm:ss');
};

// Devuelve la menor de las fechas indicadas
export const minDate = (...dates: (Date | null)[]): Date | null => {
  return minOrMax(true, ...dates);
};

// Devuelve la mayor de las fechas indicadas
export const maxDate = (...dates: (Date | null)[]): Date | null => {
  return minOrMax(false, ...dates);
};

// Devuelve la menor o la mayor de las fechas indicadas
function minOrMax(isMin: boolean = false, ...dates: (Date | null)[]): Date | null {
  if (!dates.length) return null;
  return dates.reduce((date, currentDate) => {
    if (date === null) return currentDate;
    if (currentDate === null) return date;
    return isMin ? (currentDate < date ? currentDate : date) : (currentDate > date ? currentDate : date);
  }, dates[0]);
};
